<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii">
<h1 class="title1">The Spirit Lens</h1>
<p class="subtitle">Book One of the Collegia Magica</p>
<p class="author">Carol Berg</p>
<div class="img_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?44f372ef